window.setupNewRelic = function(accountId, licenseKey, applicationId) {
    window.NREUM || (NREUM = {});
    NREUM.init = {
        privacy: {
            cookies_enabled: true
        },
        ajax: {
            deny_list: [
                "bam.nr-data.net"
            ]
        }
    };
    NREUM.loader_config = {
        accountID: accountId,
        trustKey: accountId,
        agentID: applicationId,
        licenseKey: licenseKey,
        applicationID: applicationId
    };
    NREUM.info = {
        beacon: "bam.nr-data.net",
        errorBeacon: "bam.nr-data.net",
        licenseKey: licenseKey,
        applicationID: applicationId,
        sa: 1
    };
    (()=>{
        var e, t, r = {
            8768: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    T: ()=>n,
                    p: ()=>i
                });
                const n = /(iPad|iPhone|iPod)/g.test(navigator.userAgent), i = n && Boolean("undefined" == typeof SharedWorker);
            },
            6562: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    P_: ()=>v,
                    Mt: ()=>p,
                    C5: ()=>d,
                    DL: ()=>w,
                    OP: ()=>R,
                    lF: ()=>z,
                    Yu: ()=>A,
                    Dg: ()=>h,
                    CX: ()=>f,
                    GE: ()=>y,
                    sU: ()=>M
                });
                var n = {};
                r.r(n), r.d(n, {
                    agent: ()=>x,
                    match: ()=>k,
                    version: ()=>j
                });
                var i = r(6797), o = r(909), a = r(8610);
                class s {
                    constructor(e, t){
                        try {
                            if (!e || "object" != typeof e) return (0, a.Z)("New setting a Configurable requires an object as input");
                            if (!t || "object" != typeof t) return (0, a.Z)("Setting a Configurable requires a model to set its initial properties");
                            Object.assign(this, t), Object.entries(e).forEach((e)=>{
                                let [t, r] = e;
                                const n = (0, o.q)(t);
                                n.length && r && "object" == typeof r && n.forEach((e)=>{
                                    e in r && ((0, a.Z)('"'.concat(e, '" is a protected attribute and can not be changed in feature ').concat(t, ".  It will have no effect.")), delete r[e]);
                                }), this[t] = r;
                            });
                        } catch (e) {
                            (0, a.Z)("An error occured while setting a Configurable", e);
                        }
                    }
                }
                const c = {
                    beacon: i.ce.beacon,
                    errorBeacon: i.ce.errorBeacon,
                    licenseKey: void 0,
                    applicationID: void 0,
                    sa: void 0,
                    queueTime: void 0,
                    applicationTime: void 0,
                    ttGuid: void 0,
                    user: void 0,
                    account: void 0,
                    product: void 0,
                    extra: void 0,
                    jsAttributes: {},
                    userAttributes: void 0,
                    atts: void 0,
                    transactionName: void 0,
                    tNamePlain: void 0
                }, u = {};
                function d(e) {
                    if (!e) throw new Error("All info objects require an agent identifier!");
                    if (!u[e]) throw new Error("Info for ".concat(e, " was never set"));
                    return u[e];
                }
                function f(e, t) {
                    if (!e) throw new Error("All info objects require an agent identifier!");
                    u[e] = new s(t, c), (0, i.Qy)(e, u[e], "info");
                }
                const l = {
                    allow_bfcache: !0,
                    privacy: {
                        cookies_enabled: !0
                    },
                    ajax: {
                        deny_list: void 0,
                        enabled: !0,
                        harvestTimeSeconds: 10
                    },
                    distributed_tracing: {
                        enabled: void 0,
                        exclude_newrelic_header: void 0,
                        cors_use_newrelic_header: void 0,
                        cors_use_tracecontext_headers: void 0,
                        allowed_origins: void 0
                    },
                    ssl: void 0,
                    obfuscate: void 0,
                    jserrors: {
                        enabled: !0,
                        harvestTimeSeconds: 10
                    },
                    metrics: {
                        enabled: !0
                    },
                    page_action: {
                        enabled: !0,
                        harvestTimeSeconds: 30
                    },
                    page_view_event: {
                        enabled: !0
                    },
                    page_view_timing: {
                        enabled: !0,
                        harvestTimeSeconds: 30,
                        long_task: !1
                    },
                    session_trace: {
                        enabled: !0,
                        harvestTimeSeconds: 10
                    },
                    spa: {
                        enabled: !0,
                        harvestTimeSeconds: 10
                    }
                }, g = {};
                function v(e) {
                    if (!e) throw new Error("All configuration objects require an agent identifier!");
                    if (!g[e]) throw new Error("Configuration for ".concat(e, " was never set"));
                    return g[e];
                }
                function h(e, t) {
                    if (!e) throw new Error("All configuration objects require an agent identifier!");
                    g[e] = new s(t, l), (0, i.Qy)(e, g[e], "config");
                }
                function p(e, t) {
                    if (!e) throw new Error("All configuration objects require an agent identifier!");
                    var r = v(e);
                    if (r) {
                        for(var n = t.split("."), i = 0; i < n.length - 1; i++)if ("object" != typeof (r = r[n[i]])) return;
                        r = r[n[n.length - 1]];
                    }
                    return r;
                }
                const m = {
                    accountID: void 0,
                    trustKey: void 0,
                    agentID: void 0,
                    licenseKey: void 0,
                    applicationID: void 0,
                    xpid: void 0
                }, b = {};
                function w(e) {
                    if (!e) throw new Error("All loader-config objects require an agent identifier!");
                    if (!b[e]) throw new Error("LoaderConfig for ".concat(e, " was never set"));
                    return b[e];
                }
                function y(e, t) {
                    if (!e) throw new Error("All loader-config objects require an agent identifier!");
                    b[e] = new s(t, m), (0, i.Qy)(e, b[e], "loader_config");
                }
                const A = (0, i.mF)().o;
                var x = null, j = null;
                const _ = /Version\/(\S+)\s+Safari/;
                if (navigator.userAgent) {
                    var E = navigator.userAgent, D = E.match(_);
                    D && -1 === E.indexOf("Chrome") && -1 === E.indexOf("Chromium") && (x = "Safari", j = D[1]);
                }
                function k(e, t) {
                    if (!x) return !1;
                    if (e !== x) return !1;
                    if (!t) return !0;
                    if (!j) return !1;
                    for(var r = j.split("."), n = t.split("."), i = 0; i < n.length; i++)if (n[i] !== r[i]) return !1;
                    return !0;
                }
                var S = r(5526), P = r(2374);
                const T = "NRBA_SESSION_ID";
                function N() {
                    if (!P.il) return null;
                    try {
                        let e;
                        return null === (e = window.sessionStorage.getItem(T)) && (e = (0, S.ky)(16), window.sessionStorage.setItem(T, e)), e;
                    } catch (e) {
                        return null;
                    }
                }
                var O = r(8226);
                const I = (e)=>({
                        buildEnv: O.Re,
                        customTransaction: void 0,
                        disabled: !1,
                        distMethod: O.gF,
                        isolatedBacklog: !1,
                        loaderType: void 0,
                        maxBytes: 3e4,
                        offset: Math.floor(P._A?.performance?.timeOrigin || P._A?.performance?.timing?.navigationStart || Date.now()),
                        onerror: void 0,
                        origin: "" + P._A.location,
                        ptid: void 0,
                        releaseIds: {},
                        sessionId: 1 == p(e, "privacy.cookies_enabled") ? N() : null,
                        xhrWrappable: "function" == typeof P._A.XMLHttpRequest?.prototype?.addEventListener,
                        userAgent: n,
                        version: O.q4
                    }), C = {};
                function R(e) {
                    if (!e) throw new Error("All runtime objects require an agent identifier!");
                    if (!C[e]) throw new Error("Runtime for ".concat(e, " was never set"));
                    return C[e];
                }
                function M(e, t) {
                    if (!e) throw new Error("All runtime objects require an agent identifier!");
                    C[e] = new s(t, I(e)), (0, i.Qy)(e, C[e], "runtime");
                }
                function z(e) {
                    return function(e) {
                        try {
                            const t = d(e);
                            return !!t.licenseKey && !!t.errorBeacon && !!t.applicationID;
                        } catch (e) {
                            return !1;
                        }
                    }(e);
                }
            },
            8226: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    Re: ()=>i,
                    gF: ()=>o,
                    q4: ()=>n
                });
                const n = "1.229.0", i = "PROD", o = "CDN";
            },
            9557: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    w: ()=>o
                });
                var n = r(8610);
                const i = {
                    agentIdentifier: ""
                };
                class o {
                    constructor(e){
                        try {
                            if ("object" != typeof e) return (0, n.Z)("shared context requires an object as input");
                            this.sharedContext = {}, Object.assign(this.sharedContext, i), Object.entries(e).forEach((e)=>{
                                let [t, r] = e;
                                Object.keys(i).includes(t) && (this.sharedContext[t] = r);
                            });
                        } catch (e) {
                            (0, n.Z)("An error occured while setting SharedContext", e);
                        }
                    }
                }
            },
            4329: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    L: ()=>d,
                    R: ()=>c
                });
                var n = r(3752), i = r(7022), o = r(4045), a = r(2325);
                const s = {};
                function c(e, t) {
                    const r = {
                        staged: !1,
                        priority: a.p[t] || 0
                    };
                    u(e), s[e].get(t) || s[e].set(t, r);
                }
                function u(e) {
                    e && (s[e] || (s[e] = new Map));
                }
                function d() {
                    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "", t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : "feature";
                    if (u(e), !e || !s[e].get(t)) return a(t);
                    s[e].get(t).staged = !0;
                    const r = Array.from(s[e]);
                    function a(t) {
                        const r = e ? n.ee.get(e) : n.ee, a = o.X.handlers;
                        if (r.backlog && a) {
                            var s = r.backlog[t], c = a[t];
                            if (c) {
                                for(var u = 0; s && u < s.length; ++u)f(s[u], c);
                                (0, i.D)(c, function(e, t) {
                                    (0, i.D)(t, function(t, r) {
                                        r[0].on(e, r[1]);
                                    });
                                });
                            }
                            delete a[t], r.backlog[t] = null, r.emit("drain-" + t, []);
                        }
                    }
                    r.every((e)=>{
                        let [t, r] = e;
                        return r.staged;
                    }) && (r.sort((e, t)=>e[1].priority - t[1].priority), r.forEach((e)=>{
                        let [t] = e;
                        a(t);
                    }));
                }
                function f(e, t) {
                    var r = e[1];
                    (0, i.D)(t[r], function(t, r) {
                        var n = e[0];
                        if (r[0] === n) {
                            var i = r[1], o = e[3], a = e[2];
                            i.apply(o, a);
                        }
                    });
                }
            },
            3752: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    ee: ()=>u
                });
                var n = r(6797), i = r(3916), o = r(7022), a = r(6562), s = "nr@context";
                let c = (0, n.fP)();
                var u;
                function d() {}
                function f() {
                    return new d;
                }
                function l() {
                    u.aborted = !0, u.backlog = {};
                }
                c.ee ? u = c.ee : (u = function e(t, r) {
                    var n = {}, c = {}, g = {}, v = !1;
                    try {
                        v = 16 === r.length && (0, a.OP)(r).isolatedBacklog;
                    } catch (e) {}
                    var h = {
                        on: b,
                        addEventListener: b,
                        removeEventListener: w,
                        emit: m,
                        get: A,
                        listeners: y,
                        context: p,
                        buffer: x,
                        abort: l,
                        aborted: !1,
                        isBuffering: j,
                        debugId: r,
                        backlog: v ? {} : t && "object" == typeof t.backlog ? t.backlog : {}
                    };
                    return h;
                    function p(e) {
                        return e && e instanceof d ? e : e ? (0, i.X)(e, s, f) : f();
                    }
                    function m(e, r, n, i, o) {
                        if (!1 !== o && (o = !0), !u.aborted || i) {
                            t && o && t.emit(e, r, n);
                            for(var a = p(n), s = y(e), d = s.length, f = 0; f < d; f++)s[f].apply(a, r);
                            var l = _()[c[e]];
                            return l && l.push([
                                h,
                                e,
                                r,
                                a
                            ]), a;
                        }
                    }
                    function b(e, t) {
                        n[e] = y(e).concat(t);
                    }
                    function w(e, t) {
                        var r = n[e];
                        if (r) for(var i = 0; i < r.length; i++)r[i] === t && r.splice(i, 1);
                    }
                    function y(e) {
                        return n[e] || [];
                    }
                    function A(t) {
                        return g[t] = g[t] || e(h, t);
                    }
                    function x(e, t) {
                        var r = _();
                        h.aborted || (0, o.D)(e, function(e, n) {
                            t = t || "feature", c[n] = t, t in r || (r[t] = []);
                        });
                    }
                    function j(e) {
                        return !!_()[c[e]];
                    }
                    function _() {
                        return h.backlog;
                    }
                }(void 0, "globalEE"), c.ee = u);
            },
            9252: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    E: ()=>n,
                    p: ()=>i
                });
                var n = r(3752).ee.get("handle");
                function i(e, t, r, i, o) {
                    o ? (o.buffer([
                        e
                    ], i), o.emit(e, t, r)) : (n.buffer([
                        e
                    ], i), n.emit(e, t, r));
                }
            },
            4045: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    X: ()=>o
                });
                var n = r(9252);
                o.on = a;
                var i = o.handlers = {};
                function o(e, t, r, o) {
                    a(o || n.E, i, e, t, r);
                }
                function a(e, t, r, i, o) {
                    o || (o = "feature"), e || (e = n.E);
                    var a = t[o] = t[o] || {};
                    (a[r] = a[r] || []).push([
                        e,
                        i
                    ]);
                }
            },
            8544: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    bP: ()=>s,
                    iz: ()=>c,
                    m$: ()=>a
                });
                var n = r(2374);
                let i = !1, o = !1;
                try {
                    const e = {
                        get passive () {
                            return i = !0, !1;
                        },
                        get signal () {
                            return o = !0, !1;
                        }
                    };
                    n._A.addEventListener("test", null, e), n._A.removeEventListener("test", null, e);
                } catch (e) {}
                function a(e, t) {
                    return i || o ? {
                        capture: !!e,
                        passive: i,
                        signal: t
                    } : !!e;
                }
                function s(e, t) {
                    let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                    window.addEventListener(e, t, a(r));
                }
                function c(e, t) {
                    let r = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                    document.addEventListener(e, t, a(r));
                }
            },
            5526: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    Rl: ()=>i,
                    ky: ()=>o
                });
                var n = r(2374);
                function i() {
                    var e = null, t = 0, r = n._A?.crypto || n._A?.msCrypto;
                    function i() {
                        return e ? 15 & e[t++] : 16 * Math.random() | 0;
                    }
                    r && r.getRandomValues && (e = r.getRandomValues(new Uint8Array(31)));
                    for(var o, a = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx", s = "", c = 0; c < a.length; c++)s += "x" === (o = a[c]) ? i().toString(16) : "y" === o ? (o = 3 & i() | 8).toString(16) : o;
                    return s;
                }
                function o(e) {
                    var t = null, r = 0, n = self.crypto || self.msCrypto;
                    n && n.getRandomValues && Uint8Array && (t = n.getRandomValues(new Uint8Array(31)));
                    for(var i = [], o = 0; o < e; o++)i.push(a().toString(16));
                    return i.join("");
                    function a() {
                        return t ? 15 & t[r++] : 16 * Math.random() | 0;
                    }
                }
            },
            2053: (e, t, r)=>{
                "use strict";
                function n() {
                    return Math.round(performance.now());
                }
                r.d(t, {
                    z: ()=>n
                });
            },
            8610: (e, t, r)=>{
                "use strict";
                function n(e, t) {
                    console && console.warn && "function" == typeof console.warn && (console.warn("New Relic: ".concat(e)), t && console.warn(t));
                }
                r.d(t, {
                    Z: ()=>n
                });
            },
            3916: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    X: ()=>i
                });
                var n = Object.prototype.hasOwnProperty;
                function i(e, t, r) {
                    if (n.call(e, t)) return e[t];
                    var i = r();
                    if (Object.defineProperty && Object.keys) try {
                        return Object.defineProperty(e, t, {
                            value: i,
                            writable: !0,
                            enumerable: !1
                        }), i;
                    } catch (e) {}
                    return e[t] = i, i;
                }
            },
            2374: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    _A: ()=>o,
                    il: ()=>n,
                    lW: ()=>a,
                    v6: ()=>i
                });
                const n = Boolean("undefined" != typeof window && window.document), i = Boolean("undefined" != typeof WorkerGlobalScope && self.navigator instanceof WorkerNavigator);
                let o = (()=>{
                    if (n) return window;
                    if (i) {
                        if ("undefined" != typeof globalThis && globalThis instanceof WorkerGlobalScope) return globalThis;
                        if (self instanceof WorkerGlobalScope) return self;
                    }
                    throw new Error('New Relic browser agent shutting down due to error: Unable to locate global scope. This is possibly due to code redefining browser global variables like "self" and "window".');
                })();
                function a() {
                    return o;
                }
            },
            7022: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    D: ()=>i
                });
                var n = Object.prototype.hasOwnProperty;
                function i(e, t) {
                    var r = [], i = "", o = 0;
                    for(i in e)n.call(e, i) && (r[o] = t(i, e[i]), o += 1);
                    return r;
                }
            },
            2438: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    P: ()=>o
                });
                var n = r(3752);
                const i = ()=>{
                    const e = new WeakSet;
                    return (t, r)=>{
                        if ("object" == typeof r && null !== r) {
                            if (e.has(r)) return;
                            e.add(r);
                        }
                        return r;
                    };
                };
                function o(e) {
                    try {
                        return JSON.stringify(e, i());
                    } catch (e) {
                        try {
                            n.ee.emit("internal-error", [
                                e
                            ]);
                        } catch (e) {}
                    }
                }
            },
            2650: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    K: ()=>a,
                    b: ()=>o
                });
                var n = r(8544);
                function i() {
                    return "undefined" == typeof document || "complete" === document.readyState;
                }
                function o(e, t) {
                    if (i()) return e();
                    (0, n.bP)("load", e, t);
                }
                function a(e) {
                    if (i()) return e();
                    (0, n.iz)("DOMContentLoaded", e);
                }
            },
            6797: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    EZ: ()=>u,
                    Qy: ()=>c,
                    ce: ()=>o,
                    fP: ()=>a,
                    gG: ()=>d,
                    mF: ()=>s
                });
                var n = r(2053), i = r(2374);
                const o = {
                    beacon: "bam.nr-data.net",
                    errorBeacon: "bam.nr-data.net"
                };
                function a() {
                    return i._A.NREUM || (i._A.NREUM = {}), void 0 === i._A.newrelic && (i._A.newrelic = i._A.NREUM), i._A.NREUM;
                }
                function s() {
                    let e = a();
                    return e.o || (e.o = {
                        ST: i._A.setTimeout,
                        SI: i._A.setImmediate,
                        CT: i._A.clearTimeout,
                        XHR: i._A.XMLHttpRequest,
                        REQ: i._A.Request,
                        EV: i._A.Event,
                        PR: i._A.Promise,
                        MO: i._A.MutationObserver,
                        FETCH: i._A.fetch
                    }), e;
                }
                function c(e, t, r) {
                    let i = a();
                    const o = i.initializedAgents || {}, s = o[e] || {};
                    return Object.keys(s).length || (s.initializedAt = {
                        ms: (0, n.z)(),
                        date: new Date
                    }), i.initializedAgents = {
                        ...o,
                        [e]: {
                            ...s,
                            [r]: t
                        }
                    }, i;
                }
                function u(e, t) {
                    a()[e] = t;
                }
                function d() {
                    return function() {
                        let e = a();
                        const t = e.info || {};
                        e.info = {
                            beacon: o.beacon,
                            errorBeacon: o.errorBeacon,
                            ...t
                        };
                    }(), function() {
                        let e = a();
                        const t = e.init || {};
                        e.init = {
                            ...t
                        };
                    }(), s(), function() {
                        let e = a();
                        const t = e.loader_config || {};
                        e.loader_config = {
                            ...t
                        };
                    }(), a();
                }
            },
            6998: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    N: ()=>i
                });
                var n = r(8544);
                function i(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    return void (0, n.iz)("visibilitychange", function() {
                        if (t) {
                            if ("hidden" != document.visibilityState) return;
                            e();
                        }
                        e(document.visibilityState);
                    });
                }
            },
            6034: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    gF: ()=>o,
                    mY: ()=>i,
                    t9: ()=>n,
                    vz: ()=>s,
                    xS: ()=>a
                });
                const n = r(2325).D.metrics, i = "sm", o = "cm", a = "storeSupportabilityMetrics", s = "storeEventMetrics";
            },
            2484: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    Dz: ()=>i,
                    OJ: ()=>a,
                    qw: ()=>o,
                    t9: ()=>n
                });
                const n = r(2325).D.pageViewEvent, i = "firstbyte", o = "domcontent", a = "windowload";
            },
            6382: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    t: ()=>n
                });
                const n = r(2325).D.pageViewTiming;
            },
            1509: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    W: ()=>s
                });
                var n = r(6562), i = r(3752), o = r(5432), a = r(6797);
                class s {
                    constructor(e, t, r){
                        this.agentIdentifier = e, this.aggregator = t, this.ee = i.ee.get(e, (0, n.OP)(this.agentIdentifier).isolatedBacklog), this.featureName = r, this.blocked = !1, this.checkConfiguration();
                    }
                    checkConfiguration() {
                        if (!(0, n.lF)(this.agentIdentifier)) {
                            let e = {
                                ...(0, a.gG)().info?.jsAttributes
                            };
                            try {
                                e = {
                                    ...e,
                                    ...(0, n.C5)(this.agentIdentifier)?.jsAttributes
                                };
                            } catch (e) {}
                            (0, o.j)(this.agentIdentifier, {
                                ...(0, a.gG)(),
                                info: {
                                    ...(0, a.gG)().info,
                                    jsAttributes: e
                                }
                            });
                        }
                    }
                }
            },
            5432: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    j: ()=>y
                });
                var n = r(8683), i = r.n(n), o = r(2325), a = r(6562), s = r(9252), c = r(7022), u = r(3752), d = r(2053), f = r(4329), l = r(2650), g = r(2374), v = r(8610), h = r(6034);
                var p = r(6797);
                const m = {
                    stn: [
                        o.D.sessionTrace
                    ],
                    err: [
                        o.D.jserrors,
                        o.D.metrics
                    ],
                    ins: [
                        o.D.pageAction
                    ],
                    spa: [
                        o.D.spa
                    ]
                };
                const b = {};
                function w() {
                    const e = (0, p.gG)();
                    [
                        "setErrorHandler",
                        "finished",
                        "addToTrace",
                        "inlineHit",
                        "addRelease",
                        "addPageAction",
                        "setCurrentRouteName",
                        "setPageViewName",
                        "setCustomAttribute",
                        "interaction",
                        "noticeError"
                    ].forEach((t)=>{
                        e[t] = function() {
                            for(var r = arguments.length, n = new Array(r), i = 0; i < r; i++)n[i] = arguments[i];
                            return function(t) {
                                for(var r = arguments.length, n = new Array(r > 1 ? r - 1 : 0), i = 1; i < r; i++)n[i - 1] = arguments[i];
                                let o = [];
                                return Object.values(e.initializedAgents).forEach((e)=>{
                                    e.exposed && e.api[t] && o.push(e.api[t](...n));
                                }), o.length > 1 ? returnsVals : o[0];
                            }(t, ...n);
                        };
                    });
                }
                function y(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0, y = arguments.length > 3 ? arguments[3] : void 0, { init: A, info: x, loader_config: j, runtime: _ = {
                        loaderType: n
                    }, exposed: E = !0 } = t;
                    const D = (0, p.gG)();
                    x || (A = D.init, x = D.info, j = D.loader_config), g.v6 && (x.jsAttributes = {
                        ...x.jsAttributes,
                        isWorker: !0
                    }), (0, a.CX)(e, x), (0, a.Dg)(e, A || {}), (0, a.GE)(e, j || {}), (0, a.sU)(e, _), w();
                    const k = function(e, t) {
                        t || (0, f.R)(e, "api");
                        const n = {};
                        var p = u.ee.get(e), m = p.get("tracer"), b = "api-", w = b + "ixn-";
                        function y() {}
                        (0, c.D)([
                            "setErrorHandler",
                            "finished",
                            "addToTrace",
                            "inlineHit",
                            "addRelease"
                        ], function(e, t) {
                            n[t] = x(b, t, !0, "api");
                        }), n.addPageAction = x(b, "addPageAction", !0, o.D.pageAction), n.setCurrentRouteName = x(b, "routeName", !0, o.D.spa), n.setPageViewName = function(t, r) {
                            if ("string" == typeof t) return "/" !== t.charAt(0) && (t = "/" + t), (0, a.OP)(e).customTransaction = (r || "http://custom.transaction") + t, x(b, "setPageViewName", !0, "api")();
                        }, n.setCustomAttribute = function(t, r) {
                            const n = (0, a.C5)(e);
                            return (0, a.CX)(e, {
                                ...n,
                                jsAttributes: {
                                    ...n.jsAttributes,
                                    [t]: r
                                }
                            }), x(b, "setCustomAttribute", !0, "api")();
                        }, n.interaction = function() {
                            return (new y).get();
                        };
                        var A = y.prototype = {
                            createTracer: function(e, t) {
                                var r = {}, n = this, i = "function" == typeof t;
                                return (0, s.p)(w + "tracer", [
                                    (0, d.z)(),
                                    e,
                                    r
                                ], n, o.D.spa, p), function() {
                                    if (m.emit((i ? "" : "no-") + "fn-start", [
                                        (0, d.z)(),
                                        n,
                                        i
                                    ], r), i) try {
                                        return t.apply(this, arguments);
                                    } catch (e) {
                                        throw m.emit("fn-err", [
                                            arguments,
                                            this,
                                            "string" == typeof e ? new Error(e) : e
                                        ], r), e;
                                    } finally{
                                        m.emit("fn-end", [
                                            (0, d.z)()
                                        ], r);
                                    }
                                };
                            }
                        };
                        function x(e, t, r, n) {
                            return function() {
                                return (0, s.p)(h.xS, [
                                    "API/" + t + "/called"
                                ], void 0, o.D.metrics, p), (0, s.p)(e + t, [
                                    (0, d.z)()
                                ].concat(i()(arguments)), r ? null : this, n, p), r ? void 0 : this;
                            };
                        }
                        function j() {
                            r.e(439).then(r.bind(r, 5692)).then((t)=>{
                                let { setAPI: r } = t;
                                r(e), (0, f.L)(e, "api");
                            }).catch(()=>(0, v.Z)("Downloading runtime APIs failed..."));
                        }
                        return (0, c.D)("actionText,setName,setAttribute,save,ignore,onEnd,getContext,end,get".split(","), function(e, t) {
                            A[t] = x(w, t, void 0, o.D.spa);
                        }), n.noticeError = function(e, t) {
                            "string" == typeof e && (e = new Error(e)), (0, s.p)(h.xS, [
                                "API/noticeError/called"
                            ], void 0, o.D.metrics, p), (0, s.p)("err", [
                                e,
                                (0, d.z)(),
                                !1,
                                t
                            ], void 0, o.D.jserrors, p);
                        }, g.v6 ? j() : (0, l.b)(()=>j(), !0), n;
                    }(e, y);
                    return (0, p.Qy)(e, k, "api"), (0, p.Qy)(e, E, "exposed"), (0, p.EZ)("activatedFeatures", b), (0, p.EZ)("setToken", (t)=>(function(e, t) {
                            var r = u.ee.get(t);
                            e && "object" == typeof e && ((0, c.D)(e, function(e, t) {
                                if (!t) return (m[e] || []).forEach((t)=>{
                                    (0, s.p)("block-" + e, [], void 0, t, r);
                                });
                                b[e] || ((0, s.p)("feat-" + e, [], void 0, m[e], r), b[e] = !0);
                            }), (0, f.L)(t, o.D.pageViewEvent));
                        })(t, e)), k;
                }
            },
            909: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    Z: ()=>i,
                    q: ()=>o
                });
                var n = r(2325);
                function i(e) {
                    switch(e){
                        case n.D.ajax:
                            return [
                                n.D.jserrors
                            ];
                        case n.D.sessionTrace:
                            return [
                                n.D.ajax,
                                n.D.pageViewEvent
                            ];
                        case n.D.pageViewTiming:
                            return [
                                n.D.pageViewEvent
                            ];
                        default:
                            return [];
                    }
                }
                function o(e) {
                    return e === n.D.jserrors ? [] : [
                        "auto"
                    ];
                }
            },
            2325: (e, t, r)=>{
                "use strict";
                r.d(t, {
                    D: ()=>n,
                    p: ()=>i
                });
                const n = {
                    ajax: "ajax",
                    jserrors: "jserrors",
                    metrics: "metrics",
                    pageAction: "page_action",
                    pageViewEvent: "page_view_event",
                    pageViewTiming: "page_view_timing",
                    sessionTrace: "session_trace",
                    spa: "spa"
                }, i = {
                    [n.pageViewEvent]: 1,
                    [n.pageViewTiming]: 2,
                    [n.metrics]: 3,
                    [n.jserrors]: 4,
                    [n.ajax]: 5,
                    [n.sessionTrace]: 6,
                    [n.pageAction]: 7,
                    [n.spa]: 8
                };
            },
            8683: (e)=>{
                e.exports = function(e, t, r) {
                    t || (t = 0), void 0 === r && (r = e ? e.length : 0);
                    for(var n = -1, i = r - t || 0, o = Array(i < 0 ? 0 : i); ++n < i;)o[n] = e[t + n];
                    return o;
                };
            }
        }, n = {};
        function i(e) {
            var t = n[e];
            if (void 0 !== t) return t.exports;
            var o = n[e] = {
                exports: {}
            };
            return r[e](o, o.exports, i), o.exports;
        }
        i.m = r, i.n = (e)=>{
            var t = e && e.__esModule ? ()=>e.default : ()=>e;
            return i.d(t, {
                a: t
            }), t;
        }, i.d = (e, t)=>{
            for(var r in t)i.o(t, r) && !i.o(e, r) && Object.defineProperty(e, r, {
                enumerable: !0,
                get: t[r]
            });
        }, i.f = {}, i.e = (e)=>Promise.all(Object.keys(i.f).reduce((t, r)=>(i.f[r](e, t), t), [])), i.u = (e)=>(({
                78: "page_action-aggregate",
                147: "metrics-aggregate",
                193: "session_trace-aggregate",
                317: "jserrors-aggregate",
                348: "page_view_timing-aggregate",
                439: "async-api",
                729: "lazy-loader",
                786: "page_view_event-aggregate",
                873: "spa-aggregate",
                898: "ajax-aggregate"
            })[e] || e) + "." + ({
                78: "8658345c",
                147: "fde0a6c6",
                193: "afe7d95b",
                317: "265ba41e",
                348: "92e7c907",
                439: "71768fc8",
                729: "ff971c03",
                786: "a968183b",
                862: "5040a0e9",
                873: "6a952689",
                898: "ebcbd305"
            })[e] + "-1.229.0.min.js", i.o = (e, t)=>Object.prototype.hasOwnProperty.call(e, t), e = {}, t = "NRBA:", i.l = (r, n, o, a)=>{
            if (e[r]) e[r].push(n);
            else {
                var s, c;
                if (void 0 !== o) for(var u = document.getElementsByTagName("script"), d = 0; d < u.length; d++){
                    var f = u[d];
                    if (f.getAttribute("src") == r || f.getAttribute("data-webpack") == t + o) {
                        s = f;
                        break;
                    }
                }
                s || (c = !0, (s = document.createElement("script")).charset = "utf-8", s.timeout = 120, i.nc && s.setAttribute("nonce", i.nc), s.setAttribute("data-webpack", t + o), s.src = r), e[r] = [
                    n
                ];
                var l = (t, n)=>{
                    s.onerror = s.onload = null, clearTimeout(g);
                    var i = e[r];
                    if (delete e[r], s.parentNode && s.parentNode.removeChild(s), i && i.forEach((e)=>e(n)), t) return t(n);
                }, g = setTimeout(l.bind(null, void 0, {
                    type: "timeout",
                    target: s
                }), 12e4);
                s.onerror = l.bind(null, s.onerror), s.onload = l.bind(null, s.onload), c && document.head.appendChild(s);
            }
        }, i.r = (e)=>{
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, i.p = "https://js-agent.newrelic.com/", (()=>{
            var e = {
                521: 0,
                38: 0
            };
            i.f.j = (t, r)=>{
                var n = i.o(e, t) ? e[t] : void 0;
                if (0 !== n) {
                    if (n) r.push(n[2]);
                    else {
                        var o = new Promise((r, i)=>n = e[t] = [
                                r,
                                i
                            ]);
                        r.push(n[2] = o);
                        var a = i.p + i.u(t), s = new Error;
                        i.l(a, (r)=>{
                            if (i.o(e, t) && (0 !== (n = e[t]) && (e[t] = void 0), n)) {
                                var o = r && ("load" === r.type ? "missing" : r.type), a = r && r.target && r.target.src;
                                s.message = "Loading chunk " + t + " failed.\n(" + o + ": " + a + ")", s.name = "ChunkLoadError", s.type = o, s.request = a, n[1](s);
                            }
                        }, "chunk-" + t, t);
                    }
                }
            };
            var t = (t, r)=>{
                var n, o, [a, s, c] = r, u = 0;
                if (a.some((t)=>0 !== e[t])) {
                    for(n in s)i.o(s, n) && (i.m[n] = s[n]);
                    if (c) c(i);
                }
                for(t && t(r); u < a.length; u++)o = a[u], i.o(e, o) && e[o] && e[o][0](), e[o] = 0;
            }, r = window.webpackChunkNRBA = window.webpackChunkNRBA || [];
            r.forEach(t.bind(null, 0)), r.push = t.bind(null, r.push.bind(r));
        })();
        var o = {};
        (()=>{
            "use strict";
            i.r(o);
            var e = i(2325), t = i(6562);
            const r = Object.values(e.D);
            function n(e) {
                const n = {};
                return r.forEach((r)=>{
                    n[r] = function(e, r) {
                        return !1 !== (0, t.Mt)(r, "".concat(e, ".enabled"));
                    }(r, e);
                }), n;
            }
            var a = i(5432), s = i(909), c = i(9252), u = i(8768), d = i(4329), f = i(1509), l = i(2650), g = i(2374), v = i(8610);
            class h extends f.W {
                constructor(e, t, r){
                    let n = !(arguments.length > 3 && void 0 !== arguments[3]) || arguments[3];
                    super(e, t, r), this.hasAggregator = !1, this.auto = n, this.abortHandler, n && (0, d.R)(e, r);
                }
                importAggregator() {
                    if (this.hasAggregator || !this.auto) return;
                    this.hasAggregator = !0;
                    const e = async ()=>{
                        try {
                            const { lazyLoader: e } = await i.e(729).then(i.bind(i, 8110)), { Aggregate: t } = await e(this.featureName, "aggregate");
                            new t(this.agentIdentifier, this.aggregator);
                        } catch (e) {
                            (0, v.Z)("Downloading ".concat(this.featureName, " failed...")), this.abortHandler?.();
                        }
                    };
                    g.v6 ? e() : (0, l.b)(()=>e(), !0);
                }
            }
            var p, m, b, w = i(2484), y = i(2053);
            class A extends h {
                constructor(r, n){
                    let i = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                    if (super(r, n, w.t9, i), ("undefined" == typeof PerformanceNavigationTiming || u.T) && "undefined" != typeof PerformanceTiming) {
                        const n = (0, t.OP)(r);
                        n[w.Dz] = Math.max(Date.now() - n.offset, 0), (0, l.K)(()=>n[w.qw] = Math.max((0, y.z)() - n[w.Dz], 0)), (0, l.b)(()=>{
                            const t = (0, y.z)();
                            n[w.OJ] = Math.max(t - n[w.Dz], 0), (0, c.p)("timing", [
                                "load",
                                t
                            ], void 0, e.D.pageViewTiming, this.ee);
                        });
                    }
                    this.importAggregator();
                }
            }
            p = A, m = "featureName", b = w.t9, (m = function(e) {
                var t = function(e, t) {
                    if ("object" != typeof e || null === e) return e;
                    var r = e[Symbol.toPrimitive];
                    if (void 0 !== r) {
                        var n = r.call(e, t || "default");
                        if ("object" != typeof n) return n;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return ("string" === t ? String : Number)(e);
                }(e, "string");
                return "symbol" == typeof t ? t : String(t);
            }(m)) in p ? Object.defineProperty(p, m, {
                value: b,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : p[m] = b;
            var x = i(9557), j = i(7022);
            class _ extends x.w {
                constructor(e){
                    super(e), this.aggregatedData = {};
                }
                store(e, t, r, n, i) {
                    var o = this.getBucket(e, t, r, i);
                    return o.metrics = function(e, t) {
                        t || (t = {
                            count: 0
                        });
                        return t.count += 1, (0, j.D)(e, function(e, r) {
                            t[e] = E(r, t[e]);
                        }), t;
                    }(n, o.metrics), o;
                }
                merge(e, t, r, n, i) {
                    var o = this.getBucket(e, t, n, i);
                    if (o.metrics) {
                        var a = o.metrics;
                        a.count += r.count, (0, j.D)(r, function(e, t) {
                            if ("count" !== e) {
                                var n = a[e], i = r[e];
                                i && !i.c ? a[e] = E(i.t, n) : a[e] = function(e, t) {
                                    if (!t) return e;
                                    t.c || (t = D(t.t));
                                    return t.min = Math.min(e.min, t.min), t.max = Math.max(e.max, t.max), t.t += e.t, t.sos += e.sos, t.c += e.c, t;
                                }(i, a[e]);
                            }
                        });
                    } else o.metrics = r;
                }
                storeMetric(e, t, r, n) {
                    var i = this.getBucket(e, t, r);
                    return i.stats = E(n, i.stats), i;
                }
                getBucket(e, t, r, n) {
                    this.aggregatedData[e] || (this.aggregatedData[e] = {});
                    var i = this.aggregatedData[e][t];
                    return i || (i = this.aggregatedData[e][t] = {
                        params: r || {}
                    }, n && (i.custom = n)), i;
                }
                get(e, t) {
                    return t ? this.aggregatedData[e] && this.aggregatedData[e][t] : this.aggregatedData[e];
                }
                take(e) {
                    for(var t = {}, r = "", n = !1, i = 0; i < e.length; i++)t[r = e[i]] = k(this.aggregatedData[r]), t[r].length && (n = !0), delete this.aggregatedData[r];
                    return n ? t : null;
                }
            }
            function E(e, t) {
                return null == e ? function(e) {
                    e ? e.c++ : e = {
                        c: 1
                    };
                    return e;
                }(t) : t ? (t.c || (t = D(t.t)), t.c += 1, t.t += e, t.sos += e * e, e > t.max && (t.max = e), e < t.min && (t.min = e), t) : {
                    t: e
                };
            }
            function D(e) {
                return {
                    t: e,
                    min: e,
                    max: e,
                    sos: e * e,
                    c: 1
                };
            }
            function k(e) {
                return "object" != typeof e ? [] : (0, j.D)(e, S);
            }
            function S(e, t) {
                return t;
            }
            var P = i(6797), T = i(5526), N = i(2438);
            var O = i(6998), I = i(8544), C = i(6382);
            class R extends h {
                constructor(e, r){
                    let n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                    super(e, r, C.t, n), g.il && ((0, t.OP)(e).initHidden = Boolean("hidden" === document.visibilityState), (0, O.N)(()=>(0, c.p)("docHidden", [
                            (0, y.z)()
                        ], void 0, C.t, this.ee), !0), (0, I.bP)("pagehide", ()=>(0, c.p)("winPagehide", [
                            (0, y.z)()
                        ], void 0, C.t, this.ee)), this.importAggregator());
                }
            }
            !function(e, t, r) {
                (t = function(e) {
                    var t = function(e, t) {
                        if ("object" != typeof e || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == typeof t ? t : String(t);
                }(t)) in e ? Object.defineProperty(e, t, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = r;
            }(R, "featureName", C.t);
            const M = Boolean(g._A?.Worker), z = Boolean(g._A?.SharedWorker), B = Boolean(g._A?.navigator?.serviceWorker);
            let q, W, V;
            var L = i(6034);
            class Z extends h {
                constructor(t, r){
                    let n = !(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2];
                    super(t, r, L.t9, n), function(e) {
                        if (!q) {
                            if (M) {
                                q = Worker;
                                try {
                                    g._A.Worker = r(q, "Dedicated");
                                } catch (e) {
                                    o(e, "Dedicated");
                                }
                                if (z) {
                                    W = SharedWorker;
                                    try {
                                        g._A.SharedWorker = r(W, "Shared");
                                    } catch (e) {
                                        o(e, "Shared");
                                    }
                                } else n("Shared");
                                if (B) {
                                    V = navigator.serviceWorker.register;
                                    try {
                                        g._A.navigator.serviceWorker.register = (t = V, function() {
                                            for(var e = arguments.length, r = new Array(e), n = 0; n < e; n++)r[n] = arguments[n];
                                            return i("Service", r[1]?.type), t.apply(navigator.serviceWorker, r);
                                        });
                                    } catch (e) {
                                        o(e, "Service");
                                    }
                                } else n("Service");
                                var t;
                                return;
                            }
                            n("All");
                        }
                        function r(e, t) {
                            return "undefined" == typeof Proxy ? e : new Proxy(e, {
                                construct: (e, r)=>(i(t, r[1]?.type), new e(...r))
                            });
                        }
                        function n(t) {
                            g.v6 || e("Workers/".concat(t, "/Unavailable"));
                        }
                        function i(t, r) {
                            e("Workers/".concat(t, "module" === r ? "/Module" : "/Classic"));
                        }
                        function o(t, r) {
                            e("Workers/".concat(r, "/SM/Unsupported")), (0, v.Z)("NR Agent: Unable to capture ".concat(r, " workers."), t);
                        }
                    }((t)=>(0, c.p)(L.xS, [
                            t
                        ], void 0, e.D.metrics, this.ee)), this.importAggregator();
                }
            }
            !function(e, t, r) {
                (t = function(e) {
                    var t = function(e, t) {
                        if ("object" != typeof e || null === e) return e;
                        var r = e[Symbol.toPrimitive];
                        if (void 0 !== r) {
                            var n = r.call(e, t || "default");
                            if ("object" != typeof n) return n;
                            throw new TypeError("@@toPrimitive must return a primitive value.");
                        }
                        return ("string" === t ? String : Number)(e);
                    }(e, "string");
                    return "symbol" == typeof t ? t : String(t);
                }(t)) in e ? Object.defineProperty(e, t, {
                    value: r,
                    enumerable: !0,
                    configurable: !0,
                    writable: !0
                }) : e[t] = r;
            }(Z, "featureName", L.t9), new class {
                constructor(e){
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : (0, T.ky)(16);
                    this.agentIdentifier = t, this.sharedAggregator = new _({
                        agentIdentifier: this.agentIdentifier
                    }), this.features = {}, this.desiredFeatures = new Set(e.features || []), this.desiredFeatures.add(A), Object.assign(this, (0, a.j)(this.agentIdentifier, e, e.loaderType || "agent")), this.start();
                }
                get config() {
                    return {
                        info: (0, t.C5)(this.agentIdentifier),
                        init: (0, t.P_)(this.agentIdentifier),
                        loader_config: (0, t.DL)(this.agentIdentifier),
                        runtime: (0, t.OP)(this.agentIdentifier)
                    };
                }
                start() {
                    const t = "features";
                    try {
                        const r = n(this.agentIdentifier), i = Array.from(this.desiredFeatures);
                        i.sort((t, r)=>e.p[t.featureName] - e.p[r.featureName]), i.forEach((t)=>{
                            if (r[t.featureName] || t.featureName === e.D.pageViewEvent) {
                                const e = (0, s.Z)(t.featureName);
                                e.every((e)=>r[e]) || (0, v.Z)("".concat(t.featureName, " is enabled but one or more dependent features has been disabled (").concat((0, N.P)(e), "). This may cause unintended consequences or missing data...")), this.features[t.featureName] = new t(this.agentIdentifier, this.sharedAggregator);
                            }
                        }), (0, P.Qy)(this.agentIdentifier, this.features, t);
                    } catch (e) {
                        (0, v.Z)("Failed to initialize all enabled instrument classes (agent aborted) -", e);
                        for(const e in this.features)this.features[e].abortHandler?.();
                        const r = (0, P.fP)();
                        return delete r.initializedAgents[this.agentIdentifier]?.api, delete r.initializedAgents[this.agentIdentifier]?.[t], delete this.sharedAggregator, r.ee?.abort(), delete r.ee?.get(this.agentIdentifier), !1;
                    }
                }
            }({
                features: [
                    A,
                    R,
                    Z
                ],
                loaderType: "lite"
            });
        })(), window.NRBA = o;
    })();
};

//# sourceMappingURL=member-portal-elm.95dd2b77.js.map
